import { Record } from "immutable";

const UI_PERMISSIONS = Record({
    SUPPLY_CHAIN_VIEW: "case_details_supply_chain_view",
    SUPPLY_CHAIN_EDIT: "case_details_supply_chain_edit",
    ASSOCIATES_VIEW: "case_details_applicants_view",
    ASSOCIATES_EDIT: "case_details_applicants_edit",
    ADDRESS_VIEW: "case_details_addresses_view",
    ADDRESS_EDIT: "case_details_addresses_edit",
    BANK_ACCOUNTS_VIEW: "case_details_bank_accounts_view",
    BANK_ACCOUNTS_EDIT: "case_details_bank_accounts_edit",
    BANK_STATEMENT_ANALYSIS_VIEW:
        "credit_appraisal_bank_statement_analysis_view",
    BANK_STATEMENT_ANALYSIS_EDIT:
        "credit_appraisal_bank_statement_analysis_edit",
    CIBIL_VIEW: "credit_appraisal_cibil_view",
    CIBIL_EDIT: "credit_appraisal_cibil_edit",
    DATE_OF_INCORPORATION_VIEW: "credit_appraisal_date_of_incorporation_view",
    DATE_OF_INCORPORATION_EDIT: "credit_appraisal_date_of_incorporation_edit",
    QUESTIONAIRE_VIEW: "credit_appraisal_questionnaire_view",
    QUESTIONAIRE_EDIT: "credit_appraisal_questionnaire_edit",
    SALES_DATA_VIEW: "credit_appraisal_sales_data_view",
    SALES_DATA_EDIT: "credit_appraisal_sales_data_edit",
    FINANCIAL_ANALYSIS_EDIT: "financial_analysis_edit",
    FINANCIAL_ANALYSIS_VIEW: "financial_analysis_view",
    SCORECARD_BANK_EDIT: "scorecard_bank_edit",
    SCORECARD_BANK_VIEW: "scorecard_bank_view",
    DOCUMENTS_EDIT: "documents_edit",
    DOCUMENTS_VIEW: "documents_view",
    POST_SANCTION_DOCUMENTATION_VIEW: "post_sanction_documentation_view",
    POST_SANCTION_DOCUMENTATION_EDIT: "post_sanction_documentation_edit",
    PAGE_DBT_EDIT: "page_dbt_edit"
});

export default new UI_PERMISSIONS();
